import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/modal';
import { Button } from '@nextui-org/react';
import { ReactNode } from 'react';

interface Props{
    isOpen:any,
    onOpenChange:any,
    content:ReactNode
}

export default function CustomModal({isOpen, onOpenChange,content}:Props) {
        
      
        return (
          <>
            {/* <Button variant="solid" onPress={onOpen}>Open Modal</Button> */}
            <Modal
              isDismissable={false}
              isKeyboardDismissDisabled={true}
              isOpen={isOpen}
              onOpenChange={onOpenChange}
            >
              <ModalContent>
                {(onClose) => (
                  <>
                    <ModalBody>
                      {content}
                    </ModalBody>
                  </>
                )}
              </ModalContent>
            </Modal>
          </>
        );
 }
